import { Theme } from '@mui/material/styles';

const getStackColors = (theme: Theme) => ({
  background: {
    paper:
      theme.palette.mode === 'dark'
        ? 'rgb(48 51 57)'
        : theme.palette.background.paper,
    dark: theme.palette.mode === 'dark' ? '#212327' : '#f5f5f5',
  },
  border: {
    default:
      theme.palette.mode === 'dark' ? 'rgb(80 85 89)' : theme.palette.divider,
  },
});

export const getStacksViewSx = (theme: Theme) => {
  const colors = getStackColors(theme);

  return {
    viewModal: {
      titleWrapper: {
        bgcolor: colors.background.paper,
        p: 2,
      },
      closeButtonWrapper: {
        display: 'flex',
        justifyContent: 'right',
      },
    },
    view: {
      titles: {
        control: {
          fontSize: '1.4rem',
          fontWeight: 600,
          textAlign: 'center',
        },
        stack: {
          fontSize: '1.4rem',
          fontWeight: 600,
          textAlign: 'center',
        },
        noModes: {
          fontSize: '1.4rem',
          fontWeight: 600,
          textAlign: 'center',
        },
      },
      controlModesAuthority: {
        wrapper: {
          border: `1px solid ${colors.border.default}`,
          background: colors.background.dark,
          p: 4,
          flex: 1,
          authorityWrapper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexBasis: '50%',
            flex: 1,
            textAlign: 'left',
          },
          authorityTitle: {
            fontSize: '1.2rem',
            fontWeight: 600,
            '@media (min-width: 1536px)': {
              fontSize: '1.5rem',
            },
          },
          buttonGroup: {
            flexBasis: '50%',
            justifyContent: 'center',
            display: 'flex',
            button: {
              width: 125,
              height: 50,
              '@media (min-width: 1920px)': {
                width: 250,
                height: 60,
                fontSize: '1.2rem',
              },
            },
          },
        },
      },
      emptyState: {
        container: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        },
      },
      editButtonWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        mb: 2,
      },
    },
  };
};
